var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 27,
    viewBox: "0 0 35 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2002_244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2544 25.8824H9.84816C8.88129 25.8824 8.10254 25.0992 8.10254 24.1367C8.10254 23.1742 8.88566 22.3911 9.84816 22.3911H33.25C34.2169 22.3911 34.9957 23.1742 34.9957 24.1367C34.9957 25.0992 34.2125 25.8824 33.25 25.8824H33.2544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2544 14.919H9.84816C8.88129 14.919 8.10254 14.1359 8.10254 13.1734C8.10254 12.2109 8.88566 11.4277 9.84816 11.4277H33.25C34.2169 11.4277 34.9957 12.2109 34.9957 13.1734C34.9957 14.1402 34.2125 14.919 33.25 14.919H33.2544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2544 3.95951H9.84816C8.88129 3.95951 8.10254 3.17639 8.10254 2.21389C8.10254 1.25139 8.88566 0.468262 9.84816 0.468262H33.25C34.2169 0.468262 34.9957 1.25139 34.9957 2.21389C34.9957 3.17639 34.2125 3.95951 33.25 3.95951H33.2544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.345 0C3.64 0 4.69 1.05 4.69 2.345C4.69 3.64 3.64 4.69 2.345 4.69C1.05 4.69 0 3.64 0 2.345C0 1.05 1.05 0 2.345 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.345 10.8281C3.64 10.8281 4.69 11.8781 4.69 13.1731C4.69 14.4681 3.64 15.5181 2.345 15.5181C1.05 15.5181 0 14.4681 0 13.1731C0 11.8781 1.05 10.8281 2.345 10.8281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.345 21.6562C3.64 21.6562 4.69 22.7063 4.69 24.0013C4.69 25.2963 3.64 26.3463 2.345 26.3463C1.05 26.3463 0 25.2963 0 24.0013C0 22.7063 1.05 21.6562 2.345 21.6562Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2002_244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 26.3463,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon);
export default __webpack_public_path__ + "static/media/about-icon.02cd2c1aec2d21f134115a1401d7b067.svg";
export { ForwardRef as ReactComponent };